import React from "react";
import "./battery.css";

const Battry = (props) => {
  // Get the percentage from props or set a default value
  let inputvalue = props.percentage || 0;
  let percentage = (inputvalue / 5000) * 100;
  const parking = props.parking || "--";
  const tenant = props.tenant || "--";
  const cappedPercentage = Math.min(Math.max(percentage, 0), 100);
  const bars = [];
  const totalBars = 10;
  const count = Math.ceil(cappedPercentage / 10);
  let className = "low";

  if (cappedPercentage <= 20) {
    className = "low";
  } else if (cappedPercentage <= 50) {
    className = "mediam";
  } else {
    className = "active";
  }

  for (let i = 0; i < count; i++) {
    bars.push(<div className={`bar ${className}`} key={`${className}-${i}`} />);
  }

  const remainingBars = totalBars - count;
  for (let i = 0; i < remainingBars; i++) {
    bars.push(<div className="bar" key={`default-${i}`} />);
  }

  return (
    <div
      className={`project_container ${!props.isactive ? "deactivated" : ""}`}
    >
      <div className="box">
        <strong>
          <p>{tenant}</p>
        </strong>

        <div className="box" id="container">
          <div id="projectbox">
            <div className="battery">{bars}</div>
          </div>
        </div>

        <p className="box">{inputvalue} mv</p>
        <p className="box">
          {parking
            .split(":")
            .slice(-2)
            .join(":")}{" "}
        </p>
      </div>
    </div>
  );
};

export default Battry;